import { pause, name as pauseName } from './pause'
import { laggy, name as laggyName } from './laggy'
import { logger, name as loggerName } from './logger'
import { pagination, name as paginationName } from './pagination'

const middlewares = {
	[pauseName]: pause,
	[laggyName]: laggy,
	[loggerName]: logger,
	[paginationName]: pagination,
}

export const bluheadless = (useSWRNext) => {
	return (key, fetcher, config) => {
		const { bhUse = [] } = config

		let useKeys
		// add pause middleware
		if (bhUse.includes(laggyName)) {
			const laggyIndex = bhUse.indexOf(laggyName)
			useKeys = [...bhUse.slice(0, laggyIndex + 1), pauseName, ...bhUse.slice(laggyIndex + 1)]
		} else {
			useKeys = [pauseName, ...bhUse]
		}

		const bluheadlessUse = useKeys.map((use) => middlewares[use]).filter((middleware) => !!middleware)
		const use = bluheadlessUse

		// Apply middleware
		let next = useSWRNext

		if (use) {
			for (let i = use.length; i-- > 0; ) {
				next = use[i](next)
			}
		}

		return next(key, fetcher || config.fetcher, config)
	}
}
